module.exports = __webpack_public_path__ + "static/inc2-b3382e66d2c6674ad60914c2f4f9f555.jpg";